export const search = () => {
	const searchToggle = document.querySelector('.search-toggle');
	const searchClose = document.querySelector('.search-close');
	const headerSearch = document.getElementById('header-search');
	const searchField = document.querySelector('.search-field'); // Select the search field
	const menuToggle = document.querySelector('.menu-toggle'); // Select the menu toggle
	const searchForm = headerSearch.querySelector('form'); // Assuming the form is within #header-search

	// Function to open the search
	const openSearch = () => {
		headerSearch.style.display = 'flex';
		headerSearch.setAttribute('aria-expanded', 'true');
		searchToggle.setAttribute('aria-expanded', 'true');
		searchField.focus(); // Focus the search field
		menuToggle.click();
	};

	// Function to close the search
	const closeSearch = () => {
		headerSearch.style.display = 'none';
		headerSearch.setAttribute('aria-expanded', 'false');
		searchToggle.setAttribute('aria-expanded', 'false');
		return false;
	};

	// Event listener for opening search
	searchToggle.addEventListener('click', () => {
		if (headerSearch.style.display === 'none') {
			openSearch();
			//scroll to top of window
			window.scrollTo(0, 0);
		} else {
			closeSearch();
		}
	});

	// Event listener for closing search
	searchClose.addEventListener('click', (event) => {
		event.preventDefault(); // Prevent form submission or any default action
		closeSearch();
	});

	// hide label if search field has value
	searchField.addEventListener('input', (event) => {
		// if has value, add class to parent
		searchField.parentNode.classList.toggle('has-value', event.target.value);
	});
	// set initial label visibility
	searchField.parentNode.classList.toggle('has-value', searchField.value);

	// Event listener for Enter key in search field
	searchField.addEventListener('keypress', (event) => {
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault(); // Prevent the default Enter key action
			searchForm.submit(); // Submit the form
		}
	});
};
